/**
 * VIOC booking-flow A/B experiment — main-site side.
 *
 * This repo's only job in the experiment is to bucket a visitor on the VIOC
 * landing page (`/vioc/`) and carry that assignment to the customer webapp via
 * `?uiv=` on the CTA. The customer webapp is the last gate and decides what
 * actually renders.
 *
 * Assignment must ONLY happen while the experiment is live. When the customer
 * webapp is in `preview` mode it demos a variant using a hand-typed `?uiv=`, and
 * it can only tell a hand-typed param from a real bucketed user if this repo is
 * NOT emitting `?uiv=`. So both halves flip together:
 *
 *   preview / demoing → VIOC_EXPERIMENT_ASSIGNMENT_ENABLED = false (this repo
 *                       assigns nothing; customer webapp honours hand-typed uiv)
 *   running / live    → VIOC_EXPERIMENT_ASSIGNMENT_ENABLED = true  (this repo
 *                       buckets users; customer webapp mode = 'running')
 */
export const VIOC_EXPERIMENT_COOKIE = 'exp_vioc_booking_flow'
export const VIOC_VARIANTS = ['1', '2']

export const VIOC_EXPERIMENT_ASSIGNMENT_ENABLED = true
